const internalSitePrice = (state = 0, action) => {
    switch(action.type) {
        case 'internalSitePrice':
            return action.payload;
        default:
            return state;
    }
}

export default internalSitePrice;